module.exports = __webpack_public_path__ + "img/md-ribbon.42633c14.svg";